import React, { useState, useEffect } from "react";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import { Table, Menu, Dropdown, Modal } from "antd";
import { Link } from "react-router-dom";
import moment from "moment";
import Button from "../../components/Button";
import Bridge from "../../constants/Bridge";
import Strings from "../../constants/Strings";
import $ from "jquery";

const List = () => {
  const [paginationNum, setPaginationNum] = useState(10);
  const [allForms, setAllForms] = useState([]);
  const [copyOfAllForms, setCopyOfAllForms] = useState([]);
  const [tableloader, setTableloader] = useState(false);
  const [viewModalStatus, setViewModalStatus] = useState(false);
  const [singleData, setSingleData] = useState({});

  useEffect(() => {
     if ($(window).width() < 600) {
          $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
        } else {
          $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
        }
    get_all_ecas_forms();
  }, []);

  const handleTableChange = (pagination, filters, sorter) => {
    setPaginationNum(pagination.pageSize);
  };

  const get_all_ecas_forms = () => {
    setTableloader(true);
    let param = "?consortia_user_id=" + localStorage.getItem("consortia_user_id");
    Bridge.consortia_upload
      .get(param)
      .then((result) => {
        if (result.status == "1") {
          setAllForms(result.data);
          setCopyOfAllForms(result.data);
          setTableloader(false);
        } else {
          setTableloader(false);
        }
      })
      .catch((error) => {
        setTableloader(false);
      });
  };

  const show_modal = (item) => {
    setSingleData(item);
    setViewModalStatus(true);
    let params = "?name=" + item.name;
    Bridge.audit_logs.view_consortia_upload_details(params);
  };

  const ColumnsForPHI = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: window.innerWidth > 650 ? 80 : 80,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 150,
    },
    {
      title: "Link",
      dataIndex: "link",
      key: "link",
      width: 250,
      render: (item) => {
        return (
          <>
            {item.link ? (
              <a href={item.link} target="_blank" style={{ color: "#007dfc" }}>
                {item.link}
              </a>
            ) : (
              "---"
            )}
          </>
        );
      },
    },
    {
      title: "Publication Details",
      dataIndex: "publication_details",
      key: "publication_details",
      width: 120,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: 80,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: 90,
      fixed: window.innerWidth > 650 ? "right" : false,
      render: (item) => {
        const unicodeString = item.consorta_upload_id;
        const encodedUnicodeString = btoa(unicodeString);
        let consr_us_id = localStorage.getItem("consortia_user_id");

        const menu = (
          <Menu className="action-menu participant-action-menu">
            {item.consortia_user_id == consr_us_id && (
              <Menu.Item key={`edit_${item.key}`}>
                <a
                  className="action-buttons"
                  href={`/consortia-upload/edit?single=${encodedUnicodeString}`}
                >
                  <i
                    className="fas fa-pencil-alt"
                    style={{ color: "#000", fontSize: 18 }}
                  ></i>
                  <span style={{ fontSize: 14, marginLeft: 10 }}>Update</span>
                </a>
              </Menu.Item>
            )}
            <Menu.Item key={`view_details${item.key}`}>
              <a
                className="action-buttons"
                href={"#!"}
                onClick={() => show_modal(item)}
              >
                <i
                  className="fas fa-eye"
                  style={{ color: "#000", fontSize: 18 }}
                ></i>
                <span style={{ fontSize: 14, marginLeft: 10 }}>View</span>
              </a>
            </Menu.Item>
          </Menu>
        );
        return (
          <div style={{ width: "100%" }}>
            <Dropdown overlay={menu}>
              <a
                className="ant-dropdown-link action-link"
                onClick={(e) => e.preventDefault()}
              >
                <i className="fas fa-ellipsis-v"></i>
              </a>
            </Dropdown>
          </div>
        );
      },
    },
  ];

  const dataSource =
    allForms &&
    allForms.map((item, index) => {
      let splitted_date = item.date_created.split("T")[0];
      return {
        key: index,
        name: item.name ? item.name : "---",
        link: item,
        title: item.title ? item.title : "---",
        publication_details: item.publication_details
          ? item.publication_details.length > 90
            ? item.publication_details.substring(0, 90) + "..."
            : item.publication_details
          : "---",
        date: item.date_created
          ? moment(splitted_date).format("MM/DD/YYYY")
          : "---",
        action: item,
      };
    });

  return (
    <div>
      <Header />
      <div className="row">
        <Sidebar />
        <div
          className="col-lg-10"
          style={{
            marginLeft: "auto",
            backgroundColor: "#F5F5F5",
          }}
        >
          <div
            className="wrapper clearfix records-wrapper top-space"
            style={{ margin: 0, boxShadow: "none" }}
          >
            <div className="multisteps-form">
              <div className="row">
                <div className="col-12 col-lg-12 m-auto ecas-table">
                  <div className="ambassador-heading-section mb-2">
                    <h3 className="section-heading">
                      {Strings.consortaiUploadList} - (Total: {allForms.length})
                    </h3>
                    <Button
                      to="/consortia-upload/add"
                      isClickable={false}
                      style={{
                        fontSize: 14,
                        marginBottom: 15,
                        width: 218,
                        position: "relative",
                        top: 27,
                        float: "right",
                        height: "fit-content",
                      }}
                    >
                      <i className="fas fa-plus"></i>&nbsp; New Consortia Upload
                    </Button>
                  </div>
                  <div className="ecas-form-list">
                    <Table
                      dataSource={dataSource}
                      loading={tableloader}
                      pagination={{ pageSize: paginationNum }}
                      columns={ColumnsForPHI}
                      scroll={{ x: window.innerWidth > 650 ? 700 : 700 }}
                      onChange={handleTableChange}
                    />
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        title="View Details"
        visible={viewModalStatus}
        onOk={() => setViewModalStatus(false)}
        onCancel={() => setViewModalStatus(false)}
        okText={"Ok"}
        cancelText={"Cancel"}
      >
        <div style={{ padding: "13px 10px" }}>
          <p style={{ fontSize: 16, paddingBottom: 7 }}>
            <strong>Name:</strong> <span>{singleData.name}</span>
          </p>
          <p style={{ fontSize: 16, paddingBottom: 7 }}>
            <strong>Title:</strong> <span>{singleData.title}</span>
          </p>
          <p style={{ fontSize: 16, paddingBottom: 7 }}>
            <strong>Link:</strong>{" "}
            <span>
              <a
                href={singleData.link}
                target="_blank"
                style={{
                  padding: "4px 10px 6px 9px",
                  background: "#546adf",
                  borderRadius: 7,
                  color: "#fff",
                  fontSize: 14,
                }}
              >
                Open Link
              </a>
            </span>
          </p>
          <p style={{ fontSize: 16, paddingBottom: 7 }}>
            <strong>Publication Details:</strong>{" "}
            <span>{singleData.publication_details}</span>
          </p>
          <p style={{ fontSize: 16, paddingBottom: 7 }}>
            <strong>Date:</strong>{" "}
            <span>
              {singleData.date_created
                ? moment(singleData.date_created).format("MM/DD/YYYY")
                : "----"}
            </span>
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default List;
